
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
} from "@ant-design/icons";
import { notification } from "antd";
import { message } from "antd";
export function TextUpperCase(a) {
    return a.toUpperCase();
  }

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function sessionStoragegetItem(Key)
{
    return sessionStorage.getItem(Key);
}
export function OnlyUploadImageValidation(file) {
  console.log(file)
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'||file.type === 'application/pdf';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG/pdf file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 60;
    if (!isLt2M) {
        message.error('Image must smaller than 60MB!');
    }
    return isJpgOrPng && isLt2M;
}
export function CheckMinMaxLimit(value, MinLimit, MaxLimit) {
  if (value > MinLimit && value <= MaxLimit)
      return false
  else
      return true

}
export function StringtoIntConvert(string) {
  if (string != undefined && string != "")
      return parseInt(string, 10);
  else
      return 0
}
export const openStyledNotification = (type, messageText, description, placement = "topRight") => {
  let color = "";
  let icon = null;

  switch (type) {
    case "success":
      color = "#1ac439ff"; // green
      icon = <CheckCircleFilled style={{ color, fontSize: 20 }} />;
      break;
    case "error":
      color = "#ff4d4f"; // red
      icon = <CloseCircleFilled style={{ color, fontSize: 20 }} />;
      break;
    case "warning":
      color = "#faad14"; // yellow
      icon = <ExclamationCircleFilled style={{ color, fontSize: 20 }} />;
      break;
    default:
      color = "#1890ff"; // blue/info
      icon = <InfoCircleFilled style={{ color, fontSize: 20 }} />;
  }

  notification.open({
    message: (
      <div style={{ color: color, fontWeight: 600 }}>
        {messageText}
      </div>
    ),
    description,
    placement,
    icon: icon,
    style: {
      border: `2px solid ${color}`,
      borderRadius: "12px",
      backgroundColor: "#f6ffed", // light green for success
      padding: "16px 24px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      color: "#000",
    },
    duration: 4,
  });
};
